/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Stages/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import Stage from './Stage/index'
import TysiaButtonWithText from 'DesignSystem/TysiaButtonWithText/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Stages({
  children,
  viewPath = "/App/Account/Content/Tasks/New/Content/Board/Content/Main/Settings/Stages"
  
}) {
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
let selectedStagesValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'stages',
})
let onReorder = fromHelpers.useOnReorder({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<div
  data-testid="Stages.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Stages.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginBottom={dtSpaceXxxs}
 weight="medium"
 size="normal"
 text="Stages"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginBottom={dtSpaceLs}
 color={dtColorsNeutral500}
 text="Use stages to define how tasks go through from start to completion."
/>
</div>
<TysiaButtonWithText
  viewPath={`${viewPath}/TysiaButtonWithText`}
 marginTop={dtSpaceS}
 size="normal"
 type="primary"
 onClick={onClick}
 text="Add Stage"
/>
</div>
<div
  data-testid="Stages.List"
  data-view-path={viewPath}
 style={{'--mr-1-Z28Cbu2': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.List}`}
>
{Array.isArray(selectedStagesValueData) && selectedStagesValueData.map((item, index, list) => 
<ListItem
        key={item?.id ?? item?._id ?? index}
        context="selected_stage"
        item={item}
        index={index}
        list={list}
        hasItemKey={false}
        parentViewPath={viewPath}
        viewPath={`${viewPath}/Stage(${item?.id ?? item?._id ?? index})`}
      >
<Stage
 index={index} indexReverse={list.length - index} isFirst={index === 0} isLast={index === list.length - 1}
 item={item}
 viewPath={`${viewPath}/Stage(${item?.id ?? item?._id ?? index})`}
 onReorder={onReorder}
/>
</ListItem>
)}
</div>
{children}
</React.Fragment>)
}

  function ListItem(props) {
    let valueItem = React.useMemo(() => ({
      index: props.index,
      indexReverse: props.list.length - props.index,
      isFirst: props.index === 0,
      isLast: props.index === props.list.length - 1,
    }), [props.index, props.list])
    
    
    
    return (
      <fromData.DataProvider
      context={props.context}
      value={props.item}
      
      
      viewPath={props.viewPath}
    >
      <fromData.DataProvider
        context={`${props.context}_item`}
        value={valueItem}
        viewPath={props.viewPath}
      >
        {props.children}
      </fromData.DataProvider>
    </fromData.DataProvider>
    )
  }